var __rspack_ns_object = JSON.parse('{"title":{"singular":"Form","plural":"Forms"},"actions":{"create":"Create new Form","edit":"Edit form"}}')